import Box from '@eversports/klimt-primitives/legacy/Box'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Snackbar from '@eversports/klimt-primitives/legacy/Snackbar'
import { useEffect, useState } from 'react'

import CloseIcon from '../../../assets/icons/close.svg'
import { Localized } from '../../../localization/react'

interface Props {
  hasError?: boolean
}

const GeoLocationErrorSnackbar = ({ hasError }: Props) => {
  const [isOpen, setIsOpen] = useState(hasError)
  const handleClose = () => setIsOpen(false)

  useEffect(() => {
    setIsOpen(hasError)
  }, [hasError])

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      message={<Localized id="search-geolocation-not-found-error-message" />}
      action={
        <Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
          <Icon src={CloseIcon} size="default" color="white" />
        </Box>
      }
    />
  )
}

export default GeoLocationErrorSnackbar
